import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign(Object.assign({}, getTestId('OmniWidgetWrapperContainer')), {
  omniWidgetProps: {
    requestorSource: 'P2P',
    pageName: 'SHOP_P2P_LEAD_PAGE_PHASE2',
    lob: 'POSTPAID',
    eventListener: e => console.log(e, 'bhb'),
    sendToWidget: e => console.log(e, 'bhbhb'),
    visitorId: 'asdfgvc-dfghbvc',
    customUri: 'https://airtelp2p.bsbportal.com/p2p-new/?',
    maxRetryCount: 5,
    heartBeatTimeOut: 3000,
    widgetLoadTimeout: 5000
  },
  onModalToggle: data => {
    console.log('onModalToggle', data);
  },
  savedAddress: {
    eventName: 'CtoWSavedAddress',
    eventType: 'savedAddress',
    data: [{
      dropdownMainLabel: 'Main Address 1',
      dropdownSecondaryLabel: 'Secondary address 1',
      id: 'rakhi'
    }, {
      dropdownMainLabel: 'Main Address 2',
      dropdownSecondaryLabel: 'Secony Address 2',
      country: 'india',
      state: 'up'
    }]
  },
  analyticsData: {
    planName: 'planName',
    leadEmail: 'a@gmail.com',
    leadRtn: '{{storevalues:familyFormData.userBasicDetails.alternateNumber}}',
    leadId: '{{storeValues:cartContext.cartId}}'
  },
  onSubmit: {
    id: 'onSubmit'
  },
  onWidgetInteraction: {
    onLoadWidget: {
      actions: [{
        id: 'onLoadWidget'
      }]
    },
    onLoadAddressModal: {
      actions: [{
        id: 'onLoadAddressModal'
      }]
    },
    onClickCurrentLocation: {
      actions: [{
        id: 'onClickCurrentLocation'
      }]
    },
    onClickManualAddress: {
      actions: [{
        id: 'onClickManualAddress'
      }]
    },
    onSelectCity: {
      actions: [{
        id: 'onSelectCity'
      }]
    },
    onSelectPinCode: {
      actions: [{
        id: 'onSelectPinCode'
      }]
    },
    onSelectAddress: {
      actions: [{
        id: 'onSelectAddress'
      }]
    },
    onValidPinCode: {
      actions: [{
        id: 'onValidPinCode'
      }]
    },
    onSavingManualAddress: {
      actions: [{
        id: 'onSavingManualAddress'
      }]
    }
  },
  onUserAction: (data, metaData) => console.log('onUserAction', data, metaData)
});